module.exports = __webpack_public_path__ + "static/media/elizabethan_collar.513eeb31.svg";